import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Quest/Strategies/Domain/commands-core';
import Component from 'vue-class-component';

@Component
export default class StrategiesCommands extends VueCqrs {

	invokeCreateStrategyCommandV1(workspaceId: number, strategyId: string, name: string, description: string)
	{
		const cmd = new c.CreateStrategyCommandV1(workspaceId, strategyId, name, description);
		this.$command(cmd, strategyId);
	}

	invokeDeleteStrategyCommandV1(workspaceId: number, strategyId: string)
	{
		const cmd = new c.DeleteStrategyCommandV1(workspaceId, strategyId);
		this.$command(cmd, strategyId);
	}

	invokeUpdateStrategySettingsCommandV1(workspaceId: number, strategyId: string, name: string, description: string, currency: string, defaultPnlId: string, 
		includeCogs: boolean, includeOpex: boolean, includeOther: boolean, fiscalYearStartMonth: number)
	{
		const cmd = new c.UpdateStrategySettingsCommandV1(workspaceId, strategyId, name, description, currency, defaultPnlId, includeCogs, includeOpex, includeOther, fiscalYearStartMonth);
		this.$command(cmd, strategyId);
	}

	invokeTriggerMetricUpdatesCommandV1(workspaceId: number, id: string)
	{
		const cmd = new c.TriggerMetricUpdatesCommandV1(workspaceId, id);
		this.$command(cmd, id);
	}

	invokeUpdateResourceUnitCostsCommandV1(workspaceId: number, strategyId: string, fromYear: number, entries: string[])
	{
		const cmd = new c.UpdateResourceUnitCostsCommandV1(workspaceId, strategyId, fromYear, entries);
		this.$command(cmd, strategyId);
	}


	invokeCreateCorporateProjectPlanTemplateCommandV1(workspaceId: number, strategyId: string, templateId: string, name: string, description: string | null,
		planningHorizonInYears: number, durationInMonths: number, granularity: string, denomination: string)
	{
		const cmd = new c.CreateCorporateProjectPlanTemplateCommandV1(workspaceId, strategyId, templateId, name, description,
			planningHorizonInYears, durationInMonths, granularity, denomination);
		this.$command(cmd, templateId);
	}

	invokeUpdateCorporateProjectPlanTemplateCommandV1(workspaceId: number, strategyId: string, templateId: string, name: string, description: string | null,
		planningHorizonInYears: number, durationInMonths: number, granularity: string, denomination: string)
	{
		const cmd = new c.UpdateCorporateProjectPlanTemplateCommandV1(workspaceId, strategyId, templateId, name, description,
			planningHorizonInYears, durationInMonths, granularity, denomination);
		this.$command(cmd, templateId);
	}

	invokeDeleteCorporateProjectPlanTemplateCommandV1(workspaceId: number, strategyId: string, templateId: string)
	{
		const cmd = new c.DeleteCorporateProjectPlanTemplateCommandV1(workspaceId, strategyId, templateId);
		this.$command(cmd, templateId);
	}

	invokeSaveViewAllProjectsPageCommandV1(workspaceId: number, strategyId: string, grid: string)
	{
		const cmd = new c.SaveViewAllProjectsPageCommandV1(workspaceId, strategyId, grid);
		this.$command(cmd);
	}

	invokeSaveViewStartedProjectsPageCommandV1(workspaceId: number, strategyId: string, grid: string)
	{
		const cmd = new c.SaveViewStartedProjectsPageCommandV1(workspaceId, strategyId, grid);
		this.$command(cmd);
	}

	invokeSaveViewFinishedProjectsPageCommandV1(workspaceId: number, strategyId: string, grid: string)
	{
		const cmd = new c.SaveViewFinishedProjectsPageCommandV1(workspaceId, strategyId, grid);
		this.$command(cmd);
	}

	invokeSaveViewProposedProjectsPageCommandV1(workspaceId: number, strategyId: string, grid: string)
	{
		const cmd = new c.SaveViewProposedProjectsPageCommandV1(workspaceId, strategyId, grid);
		this.$command(cmd);
	}

	invokeSaveViewScheduledProjectsPageCommandV1(workspaceId: number, strategyId: string, grid: string)
	{
		const cmd = new c.SaveViewScheduledProjectsPageCommandV1(workspaceId, strategyId, grid);
		this.$command(cmd);
	}
}
